export default{
    detailAccountTitle: 'عنوان',
    detailAccounts:'حساب تفصیل',
    editDetailAccount:'ویرایش حساب تفصیل',
    addDetailAccount:'حساب تفصیل جدید',
    searchSubsidiaryAccount:'جست و جو بر اساس حساب معین',
}